import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getCall } from './apicalls.service';
import { HeadersService } from './headers.service';

@Injectable({
    providedIn: 'root',
})
export class SiteApiService extends HeadersService {
    constructor(public _http: HttpClient) {
        super(_http);
    }

    getFunds() {
        const url = getCall('funds', null, {
            access: localStorage.getItem('user-access'),
        });

        return this._http.get(url, this.getHeaders());
    }

    getUser(role_type: string, user_id: string = null, fund_id: number = null) {
        let params = {
            role_type: role_type,
            access: localStorage.getItem('user-access'),
        };
        if (fund_id) {
            params['fund'] = fund_id;
        }
        const url = getCall('user', user_id, params);

        return this._http.get(url, this.getHeaders());
    }

    createUser(data: any) {
        let params = {
            role_type: data.role_type,
            access: localStorage.getItem('user-access'),
        };
        data['access'] = localStorage.getItem('user-access');
        const url = getCall('create-user', null, params);
        return this._http.post(url, data, this.getHeaders());
    }

    updateUser(data: any, role_type: string) {
        let params = {
            role_type: role_type,
            access: localStorage.getItem('user-access'),
        };
        const url = getCall('user', data.id, params);

        return this._http.patch(url, data, this.getHeaders());
    }

    deleteUser(id) {
        const url = getCall('user', id);

        return this._http.delete(url, this.getHeaders());
    }

    userEmailNotify(data: any) {
        const url = getCall('investorsEmailNotify');

        return this._http.post(url, data, this.getHeaders());
    }

    getDashboard(fund_id: number, access: string, page: string = 'dealflow') {
        const params = {
            fund: fund_id,
            access: access,
            page,
        };
        const url = getCall('dashboard', null, params);

        return this._http.get(url, this.getHeaders());
    }

    getKpiDateRange(kpi: any, date_ini: string, date_end: string) {
        const data = {
            fund: kpi.fund,
            kpi: kpi.data_type,
            date_range: {
                date_start: date_ini,
                date_end,
            },
        };
        const url = getCall('daterange');

        return this._http.post(url, data, this.getHeaders());
    }

    resetPassword(email: string) {
        const data = { email: email };
        const url = getCall('resetPassword');

        return this._http.post(url, data, this.getHeaders());
    }

    resetPasswordConfirm(new_password: string, token) {
        const url = getCall('resetPasswordConfirm', token);
        const data = { new_password: new_password };

        return this._http.post(url, data, this.getHeaders());
    }

    getDealflow(access: string, fund_id: number) {
        const params = {
            fund: fund_id,
            access: access,
        };

        const url = getCall('dealflow', null, params);

        return this._http.get(url, this.getHeaders());
    }

    setDealflowMovement(data: any) {
        const url = getCall('dealflow', null, { access: data.access });
        const jsonData = {
            fund: data.fund,
            step: data.step,
            deal: data.deal,
            note: data.note,
        };
        return this._http.post(url, jsonData, this.getHeaders());
    }
}
